export default "__VITE_ASSET__DaK55NG6__"